<ws-modal-wrapper headerLabel="Form Overrides"
                  [hideCancel]="true"
                  [suppressKeyboardEvents]="true"
                  (save)="cancel()"
                  (cancel)="cancel()">
    <div class="app-ui-view">
        <ag-grid-row-count [gridApi]="gridApi"
                           [gridOptions]="gridOptions"
                           [prefix]="null"
                           [suffix]="null"
                           class="ws-flex-auto"></ag-grid-row-count>
        <ws-ag-grid-angular [gridOptions]="gridOptions"
                            [gridId]="gridId"
                            (gridReady)="onAgGridReady($event)">
        </ws-ag-grid-angular>
    </div>
</ws-modal-wrapper>
